<template>
  <div class="report">
    <button type="button" @click="goToMyReport">
      <div class="row">
        <div class="img"></div>
      </div>
      <div class="history">
        <span class="name">シェアサイクル利用</span>

        <!-- 貸出ポート名 -->
        <span class="park-name">
          {{ props.dbsReport.start_park_name }}
        </span>

        <!-- 返却時刻 -->
        <span class="end-time">{{ props.dbsReport.end_time }}</span>
      </div>
    </button>
  </div>
</template>

<script>
import dbsService from "@/services/dbs";

export default {
  name: "DbsReports",
  props: {
    dbsReport: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const goToMyReport = () => {
      dbsService.goToMyReport(props.dbsReport.id);
    };

    return {
      props,
      goToMyReport,
    };
  },
};
</script>

<style lang="scss">
.report {
  margin: 6px 0 !important;
}
.report button {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 87px;
  padding: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  // background-color: #ffffff;
  background-color: #f0f0f0 !important;
  color: #000000;
}
.report button .row .img {
  height: 85px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 85px;
  margin: 0;
  padding: 0;
  line-height: 0;
  background-image: url("~@/assets/img/material/img_share_cycle.png");
}
.report button .history {
  width: 100%;
  padding-left: 0.8vh;
  text-align: left;
  font-weight: normal;
}
.report button .history span {
  display: block;
}

.report button .history span.name {
  font-size: 15px;
  font-weight: bold;
  margin-top: 12px;
}
.report button .history span.park-name {
  font-size: 13px;
  color: #777777;
  margin-top: 6px;
}
.report button .history span.end-time {
  font-size: 12px;
  color: #777777;
  margin-top: 4px;
}

/* 横幅が320px以下の場合に適用するスタイル */
@media (max-width: 320px) {
  .report button .row:first-of-type .img {
    width: 65px;
  }
  .report button .row:nth-of-type(2) {
    width: calc(100% - 70px - 60px);
  }
  .report button .history span.name {
    font-size: 14px;
  }
  .report button .history span.park-name {
    font-size: 12px;
  }
  .report button .history span.end-time {
    font-size: 11px;
  }
  .radio input[type="radio"] + .radio-label:before {
    margin-right: 2px;
  }
}
</style>
